import { dynamicLoader } from '~/utils';

export const ComponentErrorBoundary = dynamicLoader({
  name: 'ComponentErrorBoundary',
  importFunc: () => import('./component-error-boundary'),
});

export const ComponentWrapper = dynamicLoader({
  name: 'ComponentWrapper',
  importFunc: () => import('./component-error-boundary'),
});